<script lang="ts">
export default {
  name: 'UserFeedbackModal'
}
</script>

<script setup lang="ts">
import ConfirmModal from './ConfirmModal.vue';
import { userFeedbackService } from '@/services/api';
import { ref } from 'vue';
import DropArea from './DropArea.vue';
import { UploadCloud } from 'lucide-vue-next';

defineProps<{
  show: boolean;
}>();

const emit = defineEmits<{
  close: [],
}>();

const useScreenshot = ref(false);
const details = ref('');
const loadingScreenshot = ref(false);
const errorText = ref('');
const selectedFile = ref<string>('');
const selectedFileName = ref<string>('');

function onDismiss() {
  errorText.value = '';
  useScreenshot.value = false;
  selectedFile.value = '';
  selectedFileName.value = '';
  details.value = '';
  emit('close');
}

async function handleSubmit(): Promise<boolean> {
  try {
    errorText.value = '';
    await userFeedbackService.SubmitFeedback({
      details: details.value,
      screenshot: selectedFile.value ? selectedFile.value : '',
      url: window.location.toString()
    });
    return true;
  } catch (err) {
    console.error(err);
    errorText.value = 'An error occurred while sending feedback.';
    return false;
  } finally {
    onDismiss();
  }
}

function handleScreenshotFileSelect(files: File[]) {
  if (files.length > 0) {
    const file = files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      selectedFile.value = e.target?.result as string;
      selectedFileName.value = file.name;
    };
    reader.readAsDataURL(file);
  }
}
</script>

<template>
  <ConfirmModal :show="show" theme="light" title="Submit Feedback" can-click-outside-to-dismiss
                confirmText="Submit" :action="handleSubmit" cancel-text="Cancel" :dismiss="onDismiss"
                :submitLoading="loadingScreenshot" :max-width="600">
    <div class="tw:flex tw:flex-col tw:gap-2 tw:items-center">
      <textarea class="tw:textarea tw:textarea-bordered tw:border tw:border-solid tw:w-full" v-model="details"></textarea>
      <drop-area :shouldShowOnInit="true" :accepted-file-types="['.png']" class="tw:border tw:border-dashed tw:border-gray-300 tw:rounded-md tw:w-fit-content tw:h-fit-content tw:bg-white tw:hover:bg-base-300" v-slot="{ file }" @files-selected="handleScreenshotFileSelect">
        <div class="tw:flex tw:flex-col tw:items-center">
          <button class="tw:flex tw:flex-col tw:items-center tw:gap-3 tw:w-4/5 tw:p-1" @click="file && file.click()">
            <UploadCloud />
            <p class="tw:text-center tw:text-xs">Drag and drop or click to upload a screenshot</p>
            <p class="tw:text-center tw:text-xs">{{ selectedFileName }}</p>
          </button>
          <input type="file" class="tw:hidden" />
        </div>
      </drop-area>
    </div>
  </ConfirmModal>
</template>

<style scoped>
.no-anchor-styling:link {
    text-decoration: inherit;
    color: inherit;
}

.no-anchor-styling:visited {
    text-decoration: inherit;
    color: inherit;
}
</style>
